module.exports = __webpack_public_path__ + "img/0007.10500928.png";